import { I18nProvider } from "@react-aria/i18n";
import { DateRangePicker } from "@heroui/date-picker";
import { today, getLocalTimeZone } from "@internationalized/date";
import { fechaAExcelNumero } from "../functions/functions.js";

function DateTimePicker({
  filtrosSeleccionados,
  setFiltrosSeleccionados,
}) {

  //guarda el valor de fecha
  const handleDateChange = (fecha) => {
    
    let strfechaInicio = fecha.start.day + "/" + fecha.start.month + "/" +  fecha.start.year;
    let strfechafinal = fecha.end.day + "/" + fecha.end.month + "/" + fecha.end.year;

    let fechaNumberInicial = fechaAExcelNumero(fecha.start.year, fecha.start.month, fecha.start.day);
    let fechaNumberFinal = fechaAExcelNumero(fecha.end.year, fecha.end.month, fecha.end.day);
    
    setFiltrosSeleccionados({...filtrosSeleccionados,
      fecha: fecha, 
      fechaInicio: fechaNumberInicial,
      fechaFinal: fechaNumberFinal,
      strfechaInicio: strfechaInicio,
      strfechaFinal: strfechafinal
    })
  }

  return (
    <div>
      {/* Fecha  */}
      <p className=" items-center p-1 text-sm gap-x-2 text-blanco font-semibold">
        Rango por fechas
      </p>
      <I18nProvider locale="es-ES">
        <DateRangePicker
          color="primary"
          value={filtrosSeleccionados.fecha}
          maxValue={today(getLocalTimeZone())}
          visibleMonths={2}
          variant="flat"
          autoFocus={false}
          placeholderValue={null}
          onChange={(e) => handleDateChange(e)}
          classNames={{
            base: "custom-base-date",
            input: "custom-input-date",
            inputWrapper: "custom-input-wrapper-date",
          }}
        />
      </I18nProvider>
    </div>
  );
}

export default DateTimePicker;
